import type { OpenAPI } from "simplydo/interfaces";

export const userIsConnectedTo = (
  user: OpenAPI.GET<"/users/me">["response"],
  service: string,
) => {
  return user && (user.enabledServices || []).indexOf(service) > -1;
};
